/* eslint-disable react-hooks/exhaustive-deps */

import { Formik, Form } from 'formik';

import MonthlyCommunicateTo from '../../../../../components/MonthlyCommunicateTo/MonthlyCommunicateTo';
import { CommunicateToPermissions } from '../../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import {
  DetailRequestMonthly,
  DetailRequestMonthlyDefaultProp
} from '../../../../../utils/globalPropTypes';

const MonthlyCommunicateToContainer = ({ details, communicateToPermissions }) => {
  const initialValues = {
    communicate: {
      receivers: [],
      adicionalReceivers: []
    }
  };

  return (
    <Formik initialValues={initialValues}>
      {() => (
        <Form>
          <MonthlyCommunicateTo
            communicateToPermissions={communicateToPermissions}
            details={details}
          />
        </Form>
      )}
    </Formik>
  );
};

MonthlyCommunicateToContainer.propTypes = {
  communicateToPermissions: CommunicateToPermissions,
  details: DetailRequestMonthly
};
MonthlyCommunicateToContainer.defaultProps = {
  communicateToPermissions: {
    visualize: false,
    write: false
  },
  details: DetailRequestMonthlyDefaultProp
};

export default MonthlyCommunicateToContainer;
